// frontend/src/components/Shared/AvisoCookies.js
// Aviso de cookies en las páginas públicas. Solo tiene "Aceptar": mientras
// no se acepte, el aviso se sigue mostrando en cada visita y el rastreador de
// visitas (RastreadorVisitas en App.js) no registra nada. La aceptación se
// guarda en localStorage.

import React from 'react';
import './AvisoCookies.css';

export const CLAVE_CONSENTIMIENTO = 'psytest_cookies';

export const leerConsentimiento = () => {
  try { return localStorage.getItem(CLAVE_CONSENTIMIENTO); } catch { return null; }
};

export const guardarConsentimiento = (valor) => {
  try { localStorage.setItem(CLAVE_CONSENTIMIENTO, valor); } catch { /* sin localStorage el aviso volverá a salir en la próxima visita */ }
};

const AvisoCookies = ({ onAceptar }) => (
  <div className="aviso-cookies" role="dialog" aria-live="polite" aria-labelledby="aviso-cookies-titulo">
    <div className="aviso-cookies-texto">
      <strong id="aviso-cookies-titulo">Usamos cookies</strong>
      <p>
        Utilizamos cookies para conocer cómo se usa nuestro sitio y seguir mejorándolo.
        Así podemos ofrecerte una experiencia cada vez más sencilla, rápida y agradable.
        Al hacer clic en 'Aceptar', aceptas nuestro uso de cookies.
      </p>
    </div>
    <div className="aviso-cookies-acciones">
      <button type="button" className="aviso-cookies-btn primario" onClick={onAceptar}>
        Aceptar
      </button>
    </div>
  </div>
);

export default AvisoCookies;
